import { render, staticRenderFns } from "./userLoginFinal3round2.vue?vue&type=template&id=0b4856a6&scoped=true"
import script from "./userLoginFinal3round2.vue?vue&type=script&lang=js"
export * from "./userLoginFinal3round2.vue?vue&type=script&lang=js"
import style0 from "./userLoginFinal3round2.vue?vue&type=style&index=0&id=0b4856a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4856a6",
  null
  
)

export default component.exports